






import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import MaterialCard from '../../materials/Card.vue'
import MyprofileUpdate from '../organisms/MyprofileUpdate.vue'
import { headerState } from '../../stores/header'

@Component({
  components: {
    MaterialCard,
    MyprofileUpdate,
  }
})
export default class MyProfile extends Vue {
  async created() {
    headerState.setTitle('マイプロファイル')
  }
}
